import { render, staticRenderFns } from "./editLotteryDetail.vue?vue&type=template&id=3916a714&scoped=true"
import script from "./editLotteryDetail.vue?vue&type=script&lang=js"
export * from "./editLotteryDetail.vue?vue&type=script&lang=js"
import style0 from "./editLotteryDetail.vue?vue&type=style&index=0&id=3916a714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3916a714",
  null
  
)

export default component.exports